import React from 'react';
import { oneOfType, object, string, number, func } from 'prop-types';
import EdocketDetails from './EdocketDetail';
import ErrorMessage from './ErrorMessage';

export default class ModalHelper extends React.Component {
    displayLoader() {
        return (
            <div className="loader-modal" />
        );
    }

    displayEDocket() {
        if (!this.props.modalEdocket) {
            return null;
        }
        return (
            <div className="edocket">
                <EdocketDetails
                    DraftDocketNumber={this.props.modalEdocket}
                    refID={this.props.refID}
                    closeModal={this.props.closeModal}
                    bearerToken={this.props.bearerToken}
                    dataURL={this.props.dataURL}
                    clientType={this.props.clientType}
                    sampleData={this.props.detailData}
                    updateContentDirty={this.props.updateContentDirty}
                />
            </div>
        );
    }

    displayError() {
        return (
            <ErrorMessage
                errorMessage={this.props.modalMessage}
                closeModal={this.props.closeModal}
            />
        );
    }

    render() {
        switch (this.props.modalType) {
            case 'loader':
                return this.displayLoader();
            case 'edocket':
                return this.displayEDocket();
            case 'error':
                return this.displayError();
            default:
                return null;
        }
    }
}


ModalHelper.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    modalEdocket: oneOfType([string, number]),
    modalType: oneOfType([string, object]),
    refID: oneOfType([string, number]).isRequired,
    clientType: string,
    closeModal: func.isRequired,
    bearerToken: string.isRequired,
    dataURL: string.isRequired,
    modalMessage: string,
    detailData: string,
    updateContentDirty: func
};

ModalHelper.defaultProps = {
    modalEdocket: null,
    clientType: '',
    modalType: '',
    modalMessage: '',
    detailData: '',
    updateContentDirty: null
};
